import { render, staticRenderFns } from "./ChartIntervalSelector.vue?vue&type=template&id=23c5d384"
import script from "./ChartIntervalSelector.vue?vue&type=script&lang=js"
export * from "./ChartIntervalSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports